<!-- ----------------------------------------------- -->
<template>
  <v-sheet
    v-if="this.valuesList.length != 0"
    class="container-column"
    style="height: 100%;"
  >
    <v-data-table
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="container-column"
    >
      <template v-slot:[`item.snwdp`]="{ item }">
        <span
          v-if="showSnowHighlight(item.snwdp)"
          class="tm-pc-detail-snow-color-highlight"
          :rw-info-color="setSnowInfoColor(item.snwdp)"
        >
          {{ item.snwdp }}
        </span>
        <span v-else> {{ item.snwdp }} </span>
      </template>
    </v-data-table>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]積雪 (詳細)観測値一覧カード
 * TmSnowDetailValues.vue
 * @author LIS
 */

export default {
  name: "tm-snow-detail-values",
  computed: {
    /**
     * 表示時刻設定(0:時間単位、1:10分単位) 取得
     */
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
    },
    /**
     * ヘッダ情報 取得
     */
    headersList: {
      get() {
        return this.hourList.headers;
      },
    },
    /**
     * 観測値一覧 取得
     */
    valuesList: {
      get() {
        // 時間単位
        return this.hourList.values;
      },
    },
    /**
     * 積雪深情報(時間) 取得
     */
    hourList: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.hour;
      },
    },
  },
  methods: {
    /**
     * 超過観測所 着色
     */
    setSnowInfoColor(snwdp) {
      if (snwdp <= 5) {
        return "snwNormal";
      } else if (snwdp <= 20) {
        return "snwLevel0";
      } else if (snwdp <= 50) {
        return "snwLevel1";
      } else if (snwdp <= 100) {
        return "snwLevel2";
      } else if (snwdp <= 150) {
        return "snwLevel3";
      } else if (snwdp <= 200) {
        return "snwLevel4";
      } else if (200 < snwdp) {
        return "snwLevel5";
      }
    },
    /** 超過の強調表示をするか */
    showSnowHighlight(snwdp) {
      if (snwdp > 0) {
        return true;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
